var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "url(#paint0_linear_16_439)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3491 11.3561L12.9807 13.594C6.68206 15.1118 6.39334 18.4499 12.3387 21.0165L14.9639 22.1479L15.6277 24.9283C17.1354 31.2261 20.4836 31.5157 23.0502 25.5703L26.8726 16.7361C28.5772 12.7686 26.5513 10.3479 22.3491 11.3561ZM22.2026 16.8097L18.0371 20.3308C17.8727 20.469 17.675 20.523 17.4834 20.5064C17.2918 20.4898 17.1062 20.4027 16.968 20.2383C16.7009 19.9206 16.7427 19.4365 17.0605 19.1693L21.226 15.6483C21.5438 15.3811 22.0279 15.423 22.295 15.7407C22.5622 16.0585 22.5203 16.5426 22.2026 16.8097Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_439",
    x1: 38,
    y1: 45.125,
    x2: -1.58807,
    y2: 44.2218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.4a566d479eb9c79413178164b06ae16e.svg";
export { ForwardRef as ReactComponent };